import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { customEmailSenderSchema } from "./custom-email-sender";

export const getCustomEmailSenders = {
  name: "getCustomEmailSenders" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ senders: z.array(customEmailSenderSchema) }),
};
